import DefaultInfoCard from "../../components/InfoCards/DefaultInfoCard";
import { CarouselCard } from "../../components/InfoCards/CarouselCard";
import { BannerInfoCard } from "../../components/InfoCards/BannerInfoCard";
import { contentfulToImageData, formatRichText, formatCTAS, filterConfigs , getContentBlockStyling, replaceToken} from "../../functions";
import { IconInfoCard } from "../../components/InfoCards/IconInfoCard";
import { ModalInfoCard } from "../../components/InfoCards/ModalInfoCard";
import { BorderlessInfoCard } from "../../components/InfoCards/BorderlessInfoCard";
import { LongCard } from "../../components/InfoCards/LongCard";
import { INFO_CARD_VARIANTS, CONFIGURATION_TYPE_IDS, VARIANT_STYLE_MAPPING } from "../../constants";
import { CarouselCardVariant } from "../../components/InfoCards/CarouselCardVariant";
import { BannerInfoCardVariant } from "../../components/InfoCards/BannerInfoCardVariant";
import { ConfigurableCarouselCard } from "../../components/InfoCards/ConfigurableCarouselCard";

const CARD_COMPONENT_MAP = {
	[INFO_CARD_VARIANTS.DEFAULT]: DefaultInfoCard,
	[INFO_CARD_VARIANTS.CAROUSEL_CARD]: CarouselCard,
	[INFO_CARD_VARIANTS.CAROUSEL_CARD_VARIANT]: CarouselCardVariant,
	[INFO_CARD_VARIANTS.ICON_INFO_CARD]: IconInfoCard,
	[INFO_CARD_VARIANTS.BORDERLESS_INFO_CARD]: BorderlessInfoCard,
	[INFO_CARD_VARIANTS.HORIZONTAL_INFO_CARD]: LongCard,
	[INFO_CARD_VARIANTS.PILL_IMAGE_INFO_CARD]: DefaultInfoCard,
	[INFO_CARD_VARIANTS.BANNER_CARD]: BannerInfoCard,
	[INFO_CARD_VARIANTS.BANNER_CARD_VARIANT]: BannerInfoCardVariant,
	[INFO_CARD_VARIANTS.MODAL_INFO_CARD]: ModalInfoCard,
	[INFO_CARD_VARIANTS.CONFIGURABLE_CAROUSEL_CARD]: ConfigurableCarouselCard,
};

export const formatInfoCards = (infoCards, cardVariant, formattedSectionStyles, configurations = [], siteStatus, parsedFunctions = {}) => {
	const infoCardConfig = filterConfigs(configurations, CONFIGURATION_TYPE_IDS.INFO_CARD);
	return infoCards?.map(({ fields }, index) => {
		const { ctas, cardFooter, variant, cardStyles, url, ...rest } = fields;
		const { WRAPPER_COLOR } = VARIANT_STYLE_MAPPING[variant] ?? {};
		const cardSectionStyling = {
			...formattedSectionStyles,
			cardStyling: {
				backgroundColor: WRAPPER_COLOR || formattedSectionStyles?.inverseColor,
				...getContentBlockStyling(cardStyles, variant),
			},
		};
		
		const CardComponent = CARD_COMPONENT_MAP[cardVariant] || DefaultInfoCard;
		const formattedContent = formatRichText(fields.content, siteStatus);
		const formattedHeader = fields?.headerText ? replaceToken(fields?.headerText, "customer_total", siteStatus?.customer_total) : "";
		const imageData = contentfulToImageData(fields.image);
		const formattedCtas = formatCTAS(ctas, siteStatus);
		const formattedFooter = formatRichText(cardFooter, siteStatus, [], parsedFunctions);
		const isEven = cardVariant === INFO_CARD_VARIANTS.BANNER_CARD_VARIANT && index % 2 === 0;
		return (
			<CardComponent
				key={index}
				{...rest}
				headerText={formattedHeader}
				content={formattedContent}
				imageUrl={imageData?.imageUrl}
				imageAlt={imageData?.alt}
				url={url}
				ctas={formattedCtas}
				formattedSectionStyles={cardSectionStyling}
				cardStyling={cardSectionStyling}
				footer={formattedFooter}
				isEven={isEven}
				infoCardConfig={infoCardConfig ?? {}}
				siteStatus={siteStatus}
			/>
		);
	});
};
